import PropTypes, {InferProps} from "prop-types";
import {usePrincipal, useProject} from "@betrue/front/services";
import {TaskCardView} from "./task-card.view";


export const TaskCardPropsTypes = {
  editUrl: PropTypes.string,
}
export type TaskCardProps = InferProps<typeof TaskCardPropsTypes>

export const TaskCard = (props: TaskCardProps) => {
  const [currentProject, , {createProject, updateProject, getProjectById}] = useProject()

  const [principal] = usePrincipal()

  if (!principal) return (<>...</>)
  return (
    <TaskCardView />
  );
}

TaskCard.propTypes = TaskCardPropsTypes
